import { context, actions, beAxios as axios } from './backend';
import {
    formatFormStates,
    formatFormInitData,
    formatValueList,
    formatFormType,
    genericResponseCall,
} from './utils';
import oAuth from './oAuth';

let valuelist = [];

const listenersFunc = {
    getContext() {
        return context;
    },

    getToken({ guid }) {
        return localStorage.getItem(`fmFragmentToken-${guid}`);
    },

    getNewToken({ guid }) {
        return oAuth(guid, context.loginToken).then((res) => {
            localStorage.setItem(`fmFragmentToken-${guid}`, res);
            return res;
        });
    },

    getLiteral({ literal }) {
        let item = sessionStorage.getItem('fm_newLiterals');

        if (!item) return null;
        try {
            item = JSON.parse(item);
            if (typeof item !== 'object') return null;
            return item[literal];
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    getFilteredUsers() {
        let item = sessionStorage.getItem('userFilter');

        if (!item) return null;
        try {
            item = JSON.parse(item);
            if (!Array.isArray(item)) return null;
            return item.join(', ');
        } catch (error) {
            console.error(error);
            return null;
        }
    },

    // FORMS //

    getFormInitData() {
        const getForm = (id) => {
            if (!id) {
                return Promise.resolve({ data: {} });
            }
            return axios.get(`/forms/v1/${id}`);
        };
        return new Promise((resolve, reject) => {
            getForm(context.form.id)
                .then(({ data }) => resolve(formatFormInitData(data)))
                .catch(reject);
        });
    },

    getFormStates() {
        return axios.get('/forms/v1/states').then(formatFormStates);
    },

    getValueList({ tableName }) {
        return new Promise((resolve, reject) => {
            if (valuelist[tableName]) {
                resolve(valuelist[tableName]);
            } else {
                function getValueListPage(page, list) {
                    return axios
                        .get(`/list/v1/${tableName}?page=${page}`, { headers: { count: 500 } })
                        .then((res) => {
                            if (res.data.length < 1) return list;
                            list.push(...res.data);
                            return getValueListPage(page + 1, list);
                        })
                        .then((res) => {
                            valuelist[tableName] = formatValueList(res);
                            resolve(valuelist[tableName]);
                        })
                        .catch(reject);
                }
                getValueListPage(0, []);
            }
        });
    },

    getFormType({ idTipoForm }) {
        const result = devData['getFilteredForms'][idTipoForm] || {};
        return Promise.resolve(formatFormType(result));
    },

    getRelatedEntity({ id, fromEntity, getEntity }) {
        // TODO
        return Promise.resolve([]);
    },

    getUsers() {
        return getRelatedEntity({ getEntity: 'users' });
    },

    finishActivity() {
        if (!actions) return Promise.reject('No actions setted');
        actions.finishActivity();
        return Promise.resolve();
    },

    setTitle({ title }) {
        if (!actions) return Promise.reject('No actions setted');
        actions.setTitle(title);
        return Promise.resolve();
    },

    saveData({ formData }) {
        if (!actions) return Promise.reject('No actions setted');
        if (context.form.id) {
            actions.saveData();
            return axios.put(`/forms/v1/${context.form.id}`, formData).then(({ data }) => data);
        }
        return axios.post(`/accounts/v1/${context.entity.id}/forms`, formData).then(({ data }) => {
            actions.saveData(data.id);
            return data;
        });
    },

    openDialogPicker() {
        return Promise.resolve();
    },

    openSignatureView() {
        if (!actions) return Promise.reject('No actions setted');
        const func = () => {
            actions.openSignatureView();
        };
        return genericResponseCall('openSignatureView', false, func);
    },

    showCameraImages() {
        if (!actions) return Promise.reject('No actions setted');
        actions.showCameraImages();
        return Promise.resolve();
    },

    hideCameraImages() {
        if (!actions) return Promise.reject('No actions setted');
        actions.hideCameraImages();
        return Promise.resolve();
    },

    expandImagesView() {
        if (!actions) return Promise.reject('No actions setted');
        actions.expandImagesView();
        return Promise.resolve();
    },

    collapseImagesView() {
        if (!actions) return Promise.reject('No actions setted');
        actions.collapseImagesView();
        return Promise.resolve();
    },
    showLoading() {
        if (!actions) return Promise.reject('No actions setted');
        actions.showLoading();
        return Promise.resolve();
    },

    hideLoading() {
        if (!actions) return Promise.reject('No actions setted');
        actions.hideLoading();
        return Promise.resolve();
    },

    showAlertDialog({ message, btnOk }) {
        if (!actions) return Promise.reject('No actions setted');
        const func = () => {
            actions.showAlertDialog({
                type: 'alert',
                size: 'small',
                // title: t('title_warning'),
                text: message,
                confirmText: btnOk,
                // cancelText: t('cfm_action_no'),
                // data: { id },
            });
        };
        return genericResponseCall('showAlertDialog', false, func);
    },

    showConfirmDialog({ message, btnOkStr, btnKOStr }) {
        if (!actions) return Promise.reject('No actions setted');
        const func = () => {
            actions.showConfirmDialog({
                type: 'confirm',
                size: 'small',
                // title: t('title_warning'),
                text: message,
                confirmText: btnOkStr,
                cancelText: btnKOStr,
                // data: { id },
            });
        };
        return genericResponseCall('showConfirmDialog', false, func);
    },
};

export default listenersFunc;
